import React from 'react';

import { MCButton, Spinner, TextAreaField, TextField } from 'src/components/basic';
import { MediaDropBox } from 'src/components/complex';
import BaseComponent from 'src/components/BaseComponent';

import { getSelectLabel, lang, remCss, withRouter } from 'src/helpers';

import model from './model';
import moment from 'moment/moment';
import constants from 'src/constants';
import SVGIcon from 'src/components/svg';

const apiStateId = 'updateAnswers';
class EditAppointment extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    model.on('accountSwitched', this.accountSwitched);
    this.init();
  }

  accountSwitched = () => {
    this.back();
  };

  init = () => {
    let appointmentId = this.props.router.params.id;
    this.setState({ loading: true });
    model.resetApiState(apiStateId);
    model.loadDetail(appointmentId, (err) => {
      if (err) this.back();
      this.setState({ loading: false });
    });
  };

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    model.cancel('accountSwitched', this.accountSwitched);
  }
  handleChange = (key, value) => {
    model.resetApiState(apiStateId);
    let { appointment } = model.getState();
    appointment.data[key] = value;
    model.setState({ appointment });
  };

  handleChangeAnswer = (key, value) => {
    model.resetApiState(apiStateId);
    let { appointment } = model.getState();
    appointment.data.answers[key].answer = value;
    model.setState({ appointment });
  };
  save = (e) => {
    e.preventDefault();
    model.updateAnswers(model.getState().appointment, (err, res, success) => {
      // if (success) this.props.navigation.navigate('Appointment');
      if (success) this.back();
    });
  };

  render = () => {
    if (this.state.loading)
      return (
        <div className={'mc-m-auto'}>
          <Spinner />
        </div>
      );
    let appointment = model.getState().appointment;
    if (!appointment) return null;
    let { invalid, loading, errorMessage } = model.getApiState('updateAnswers');

    return (
      <div className={'mc-container-content'}>
        <div className={'mc-container-content__header mc-flex-15'}>
          <div className={'mc-no-style-btn'} style={{ height: remCss(40) }} onClick={this.back}>
            <SVGIcon width={40} iconname={'back-icon'} />
          </div>
          <span className={'mc-grow'}>{lang.t('Edit appointment')}</span>
        </div>
        <div className={'mc-container-content__body mc-book-doctor'}>
          <div className={'mc-container-content__body-content'}>
            <div className={'mc-tab-box'}>
              <div className={'mc-tab-content '}>
                <div className={'mc-flex mc-grow'} style={{ overflow: 'auto' }}>
                  <div className={'mc-container-content__body-left'}>
                    <div className={'mc-label'}>{lang.t('Date')}</div>
                    <div className={'mc-value'}>
                      {moment(appointment.data.startDate).format('MMMM DD, yyyy')}
                    </div>
                    <div className={'mc-label'}>{lang.t('Time')}</div>
                    <div className={'mc-value'}>
                      {moment(appointment.data.startDate).format('hh:mm a')}
                    </div>
                    <div className={'mc-label'}>{lang.t('Treatments prefer')}</div>
                    <div className={'mc-value'}>
                      {getSelectLabel(
                        constants.general.appointment_types,
                        appointment.data.appointmentType
                      )}
                    </div>
                    {appointment.data.appointmentType === 'in_office' && (
                      <div className={'mc-grow mc-flex-col'}>
                        {appointment.data?.hospital.split('\n').map((txt, i) => (
                          <div className={i === 0 ? ' mc-note-2' : ''} key={i}>
                            {i === 0 ? txt.split('_')[0] : txt}
                          </div>
                        ))}
                      </div>
                    )}
                    <div className={'mc-value'}></div>
                    <div className={'mc-label'}>{lang.t('Payment')}</div>
                    <div className={'mc-value'}>
                      {appointment.data.amount} {appointment.data.currency}
                    </div>
                  </div>
                  <div className={'mc-container-content__body-center'}>
                    <div className={'mc-flex-20-col'}>
                      {errorMessage && <p className='mc-error'>{errorMessage}</p>}
                      <TextField
                        template={6}
                        name={'disease'}
                        label={'Disease'}
                        placeholder={'Fever'}
                        value={appointment.data.disease}
                        onChange={this.handleChange}
                        onBlur={model.handleBlur}
                        invalid={invalid}
                      />
                      <TextAreaField
                        template={6}
                        name={'symptoms'}
                        label={'Symptoms'}
                        placeholder={'Write your symptoms here'}
                        value={appointment.data.symptoms}
                        onChange={this.handleChange}
                        rows={2}
                        onBlur={model.handleBlur}
                        invalid={invalid}
                      />
                      {appointment.data.answers.length ? (
                        <div className={'mc-note-2'}>{lang.t('Question')}</div>
                      ) : (
                        ''
                      )}
                      {appointment.data.answers?.map((item, i) => (
                        <div className={'mc-flex-col'} key={i} style={{ marginTop: remCss(-5) }}>
                          <div className={'mc-note-text'}>{lang.t(item.question)}</div>
                          <TextAreaField
                            template={6}
                            rows={2}
                            name={i.toString()}
                            placeholder={'Answer here'}
                            value={appointment.data.answers[i].answer}
                            onChange={this.handleChangeAnswer}
                            onBlur={model.handleBlur}
                            invalid={invalid}
                          />
                        </div>
                      ))}
                      <div className={'mc-note-2'}>{lang.t('Photos / Files')}</div>
                      <MediaDropBox
                        style={{ marginTop: remCss(-15) }}
                        name={'files'}
                        labelIcon='Add File'
                        multi={true}
                        onChange={(n, v) => {
                          model.resetApiState(apiStateId);
                          model.handleChange(n, v);
                        }}
                        onChangeMedia={(file, index) => {
                          model.resetApiState(apiStateId);
                          let { appointment } = model.getState();
                          appointment.media = appointment.media.filter((item, i) => i !== index);
                          model.setState({ appointment });
                        }}
                        value={model.input('files') !== '' ? model.input('files') : []}
                        media={appointment.media || []}
                        invalid={invalid}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={'mc-container-content__body-footer mc-flex'}>
            <div className={'mc-grow'}></div>
            {model.state.appointment && (
              <MCButton primary medium radius dark disabled={loading} onClick={this.save}>
                {lang.t(loading ? 'Editing...' : 'Edit appointment')}
              </MCButton>
            )}
          </div>
        </div>
      </div>
    );
  };
}

export default withRouter(EditAppointment);
